module.exports = __webpack_public_path__ + "static/media/img_diangshang_4@2x.97dba225.png";